import { analyticsMiddleware } from '@src/analyticsManager';
import { applyMiddleware, createStore, compose } from 'redux';
import rootReducer from './rootReducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default (initialState: any) =>
  createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(analyticsMiddleware))
  );
try {
    // @ts-ignore
    store.displayName = "store";
    // @ts-ignore
    store.__docgenInfo = { "description": "", "displayName": "store", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/store/root/store.ts#store"] = { docgenInfo: store.__docgenInfo, name: "store", path: "src/store/root/store.ts#store" };
}
catch (__react_docgen_typescript_loader_error) { }